var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1768,0,0,1.1768,-42.017,-92.3854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.64,267.99L206.95,266.3L206.95,265.88L203.79,266.09L200.64,265.88L200.64,266.3L174.95,267.99L156,423.79L174.95,423.79L203.16,299.57L204.43,299.57L232.64,423.79L251.59,423.79L232.64,267.99Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,423.78L151.37,430.94L137.05,437.26C135.516,438.107 134.552,439.718 134.53,441.47L134.53,446.94L175.37,446.94C175.611,443.998 175.611,441.042 175.37,438.1C174.95,433.89 174.95,423.78 174.95,423.78L156,423.78Z",
    style: {
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53,442.31L134.53,446.94L175.37,446.94C175.37,446.94 175.56,444.94 175.56,442.31L134.53,442.31Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.51,423.78L256.14,430.94L270.46,437.26C271.994,438.107 272.958,439.718 272.98,441.47L272.98,446.94L232.14,446.94C231.899,443.998 231.899,441.042 232.14,438.1C232.56,433.89 232.56,423.78 232.56,423.78L251.51,423.78Z",
    style: {
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,442.31L273,446.94L232.14,446.94C232.14,446.94 231.96,444.94 231.95,442.31L273,442.31Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.07,195.51C164.07,195.51 134.07,237.67 134.07,240.76C134.07,243.85 138.84,267.71 146.42,269.95C154,272.19 158.21,268.27 159.61,260.41C161.01,252.55 156.24,241.32 156.24,241.32L170.24,228.69L164.07,195.51Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.25,259.29C158.25,259.29 166.95,257.88 169.2,258.44C171.45,259 173.13,264.34 173.13,264.34C173.13,264.34 173.97,272.2 172.56,273.88C171.15,275.56 164.42,277.53 161.62,278.09C158.82,278.65 152.91,272.2 150.62,268.27C148.33,264.34 152.35,257.6 158.25,259.29Z",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,193.6L164.07,195.51L174.01,261.86L233.09,261.86L242.08,195.89L234.05,192.83L204.41,186.33L170.38,193.6Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34,215.78L235.01,225.34L224.68,227.82L214.16,223.62L214.93,215.01L236.34,215.78Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.35,
    cy: 223.52,
    r: 1.82,
    style: {
      fill: "rgb(76,76,76)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.1,198.57L203.65,205.07L196.57,250.19L204.03,262.05L212.83,249.62L205.37,205.26L211.68,199.14L204.99,190.54L198.1,198.57Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75,187.29L167.32,193.6L168.09,196.66L192.94,189.77L192.75,187.29Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.59,186.52L239.02,192.83L238.26,195.89L213.4,189.01L213.59,186.52Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,192.83C239,192.83 248.62,195 254.51,198.37C260.4,201.74 261.81,209.32 258.44,217.74C255.07,226.16 244.69,225.04 239.92,222.74C235.15,220.44 233.74,212.08 234.58,208.43",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.9,184.04L191.03,185.95L191.79,205.26L204.22,196.47L217.22,205.45L218.37,186.33L214.93,183.46L193.9,184.04Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,161.07C219,161.07 226.06,159.35 227.39,152.29C228.72,145.23 216,136.64 207.18,135.12C198.36,133.6 185.43,142.75 183.33,149.05C181.23,155.35 189.43,161.64 198.21,162.98C206.99,164.32 219,161.07 219,161.07Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,162.22C192.68,162.22 188.86,156.3 187.91,161.45C186.96,166.6 190.96,168.89 192.68,168.7C194.4,168.51 192.68,162.22 192.68,162.22Z",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.49,162.22C217.49,162.22 221.31,156.3 222.26,161.45C223.21,166.6 219.26,168.89 217.49,168.7C215.72,168.51 217.49,162.22 217.49,162.22Z",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.52,173.9L193.52,186.52L204.22,196.47L216.27,186.14L216.27,174.29L193.52,173.9Z",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.92,158.4C191.92,158.4 191.34,170.23 192.3,174.05C193.26,177.87 199.55,185.88 204.51,187.6C209.47,189.32 216.34,179.01 217.87,175.6C219.4,172.19 218.82,157.66 218.82,157.66C218.82,157.66 216.73,152.66 212.53,151.18C208.33,149.7 195.35,147 191.92,158.4Z",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.85,164.68C199.85,165.58 199.44,166.31 198.93,166.31C198.42,166.31 198.01,165.58 198.01,164.68C198.01,163.78 198.42,163.05 198.93,163.05C199.44,163.05 199.85,163.78 199.85,164.68Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.56,164.68C211.56,165.58 211.15,166.31 210.64,166.31C210.13,166.31 209.72,165.58 209.72,164.68C209.72,163.78 210.13,163.05 210.64,163.05C211.15,163.05 211.56,163.78 211.56,164.68Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.84,169.24C201.743,169.217 201.643,169.205 201.543,169.205C200.841,169.205 200.263,169.783 200.263,170.485C200.263,171.187 200.841,171.765 201.543,171.765C201.643,171.765 201.743,171.753 201.84,171.73C202.242,171.738 202.634,171.608 202.95,171.36C203.56,172.077 204.454,172.49 205.395,172.49C206.299,172.49 207.162,172.109 207.77,171.44C208.067,171.633 208.415,171.734 208.77,171.73C208.867,171.753 208.967,171.765 209.067,171.765C209.769,171.765 210.347,171.187 210.347,170.485C210.347,169.783 209.769,169.205 209.067,169.205C208.967,169.205 208.867,169.217 208.77,169.24",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36,177.07L207.35,177.07",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.48,161.27C191.48,161.27 191.62,165.11 192.9,164.11C194.18,163.11 194.6,156.59 193.47,155.74C192.34,154.89 191.48,159.29 191.48,161.27Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.11,161.27C216.11,161.27 216.26,165.11 217.53,164.11C218.8,163.11 219.24,156.59 218.1,155.74C216.96,154.89 216.11,159.29 216.11,161.27Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.48,158.15C191.48,158.15 191.91,158.5 191.9,158.67C193.75,159.67 198,161.51 204.9,161.88C209.793,162.049 214.639,160.862 218.9,158.45L218.9,157.63C218.73,153.16 215.41,150.18 211.3,149.04C207.261,147.928 202.969,148.142 199.06,149.65C197.078,150.398 195.328,151.657 193.99,153.3C193.48,153.86 190.78,157.59 191.48,158.15Z",
    style: {
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.92,158.4C196.185,159.343 200.564,159.663 204.92,159.35C213.13,158.97 218.84,158.4 218.84,158.4C215.068,161.936 210.196,164.075 205.04,164.46C199.928,164.792 194.982,162.507 191.92,158.4Z",
    style: {
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.96,215.78L172.29,225.34L182.62,227.82L193.13,223.62L192.37,215.01L170.96,215.78Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.95,
    cy: 223.52,
    r: 1.82,
    style: {
      fill: "rgb(76,76,76)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.13,
    y: 261.25,
    width: 60.63,
    height: 9.54,
    style: {
      fill: "rgb(76,76,76)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.45,264.079C187.45,262.827 186.433,261.81 185.181,261.81L171.189,261.81C169.937,261.81 168.92,262.827 168.92,264.079L168.92,271.331C168.92,272.583 169.937,273.6 171.189,273.6L185.181,273.6C186.433,273.6 187.45,272.583 187.45,271.331L187.45,264.079Z",
    style: {
      fill: "rgb(76,76,76)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,264.079C235.73,262.827 234.713,261.81 233.461,261.81L219.469,261.81C218.217,261.81 217.2,262.827 217.2,264.079L217.2,271.331C217.2,272.583 218.217,273.6 219.469,273.6L233.461,273.6C234.713,273.6 235.73,272.583 235.73,271.331L235.73,264.079Z",
    style: {
      fill: "rgb(76,76,76)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.83,
    y: 261.81,
    width: 13.19,
    height: 8.42,
    style: {
      fill: "white",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.28,241.32C156.28,241.32 147.86,240.76 144.77,235.42",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.9,
    cy: 202.02,
    rx: 13.9,
    ry: 14.6,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.9,
    cy: 194.63,
    rx: 10.88,
    ry: 9.75,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.9,
    cy: 187.46,
    rx: 10.88,
    ry: 9.75,
    style: {
      fill: "rgb(204,204,204)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,166.44C232.42,166.44 232.61,180.82 233.34,185.06C234.07,189.3 237.03,194.83 241.09,194.83C243.794,194.763 246.471,194.267 249.02,193.36C251.569,192.453 253.81,195.94 258.42,195.2C263.03,194.46 262.29,188.01 262.29,185.2C262.29,182.39 261.74,161.6 261.74,161.6C261.74,161.6 262.11,159.6 260.26,159.21C259.353,159.006 258.429,158.882 257.5,158.84L257.5,154.41C256.807,153.378 255.596,152.811 254.36,152.94C251.97,152.94 251.78,153.49 251.78,153.49L251.78,149.43C251.78,149.43 249.78,146.2 247.17,147.77C246.103,148.383 245.411,149.492 245.33,150.72L245.14,154.6C245.14,154.6 240.72,152.94 240.35,155.52C239.98,158.1 239.24,174 239.24,174C238.978,171.5 238.486,169.03 237.77,166.62C236.85,164.22 232.42,164.22 232.42,166.44Z",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.14,154.64L245.51,171.6",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,153.53L251.97,171.78",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,158.88L257.13,171.6",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.75,171.42L259.53,172.15",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.24,174C239.25,175.41 239.921,176.736 241.05,177.58C242.87,178.72 246.97,181.68 247.42,186.46",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.87,446.5L72.61,446.5L91.62,313.99L105.88,313.99L86.87,446.5Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,446.5L129.64,446.5L110.63,313.99L96.38,313.99L115.39,446.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.18,446.5L274.93,446.5L293.93,313.99L308.19,313.99L289.18,446.5Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,446.5L331.95,446.5L312.94,313.99L298.69,313.99L317.7,446.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.73,
    y: 293.21,
    width: 271.93,
    height: 26.36,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 293.21,
    width: 271.93,
    height: 26.36,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81,319.57L89.89,319.57L101.82,293.21L78.74,293.21L66.81,319.57Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17,293.21L135.09,293.21L123.16,319.57L146.24,319.57L158.17,293.21Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,293.21L304.13,293.21L292.21,319.57L315.29,319.57L327.21,293.21Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.87,293.21L247.78,293.21L235.86,319.57L258.94,319.57L270.87,293.21Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.52,293.21L191.44,293.21L179.51,319.57L202.59,319.57L214.52,293.21Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.8,304.9L287.8,304.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.01,309.31L324.91,309.31",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21,308.21L106.21,308.21",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,303.25L118.84,303.25",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.37,
    y: 440.72,
    width: 77.14,
    height: 5.79,
    style: {
      fill: "rgb(38,50,56)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,440.56L344.39,440.56L364.42,331.6L375.46,331.6L395.49,440.56Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.98,372.1L382.91,372.1L380.42,358.6L359.46,358.6L356.98,372.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.81,422.37L389.09,429.82",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.22,337.62L386.2,413",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.01,446.5L456.92,446.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.37,446.5L440.36,446.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.17px"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--security-barrier--inject-47"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-47"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAuth);
export default __webpack_public_path__ + "static/media/error-auth.5e1aedf6c5ccfd673013df9ca3b11a82.svg";
export { ForwardRef as ReactComponent };